<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" title="Volver" type="button" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" type="submit" title="Guardar" class="btn btn-outline-success "><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} Campaña Autorizada</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsedEntidad = !isCollapsedEntidad"
                       [attr.aria-expanded]="!isCollapsedEntidad" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Datos Principales
                            <i *ngIf="isCollapsedEntidad" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsedEntidad" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-6">
                                <label class="col-form-label required-field" for="intEstado">Campaña</label>
                                <ng-select [items]="listCampanias"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdCampania"
                                           loadingText="Cargando..."
                                           [readonly]="!listCampanias || listCampanias.length === 0"
                                           [loading]="!listCampanias || listCampanias.length === 0"
                                           notFoundText="Campaña no encontrada"
                                           placeholder="-- Seleccione una Campaña --"
                                           clearAllText="Eliminar selección"
                                           [ngClass]="displayFieldCssNgSelect('IdCampania')">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{item.Descripcion}}">{{item.Descripcion}}</div>
                                    </ng-template>
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCampania','required')">
                                    Campaña es obligatoria
                                </div>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCampania','IdCampania_duplicated')">
                                    La Campaña ya existe
                                </div>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpActivo">Activa</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="Activa" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>

                            <div class="form-group col-md-2">

                                <label class="col-form-label" for="inpFechaAlta">Fecha Alta</label>
                                <p-calendar formControlName="FechaAlta" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>

                            </div>

                            <div class="form-group col-md-2">

                                <label class="col-form-label" for="inpFechaBajaCampania">Fecha Baja</label>
                                <p-calendar formControlName="FechaBaja" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" type="search"></p-calendar>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
